export default {
  'CouponItem.full': 'full',
  'CouponItem.available': 'available',
  'CouponItem.PickUpAgain': 'Pick up again',
  'CouponItem.ClaimItNow': 'Claim Now',
  'CouponItem.Details': 'Details'
};
